
namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class PermissionSetGrid extends SiteEntityGrid<PermissionSetRow, any> {
        protected getColumnsKey() { return 'Administration.PermissionSet'; }
        protected getDialogType() { return PermissionSetDialog; }
        protected getIdProperty() { return PermissionSetRow.idProperty; }
        protected getLocalTextPrefix() { return PermissionSetRow.localTextPrefix; }
        protected getService() { return PermissionSetService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}